var nonInteractiveBorder = {
  'elevation-s': undefined,
  'elevation-m': undefined,
  'elevation-l': undefined,
  outlined: {
    borderColor: 'base.default',
    borderWidth: '1',
    borderStyle: 'solid'
  },
  filled: undefined
};
var interactiveBorder = {
  default: {
    borderColor: 'base.default',
    borderWidth: '1',
    borderStyle: 'solid'
  },
  selected: {
    borderColor: 'product.primary.strong',
    borderWidth: '2',
    borderStyle: 'solid'
  },
  viewed: {
    borderColor: 'base.default',
    borderWidth: '1',
    borderStyle: 'solid'
  },
  error: {
    borderColor: 'feedback.negative.strong',
    borderWidth: '2',
    borderStyle: 'solid'
  }
};
var mapBorderStyles = function mapBorderStyles(isInteractive, status, variant) {
  return isInteractive ? interactiveBorder[status] : nonInteractiveBorder[variant];
};

export { mapBorderStyles };
//# sourceMappingURL=Card.mappers.js.map
